import axios from 'axios';
import { setupTokenRenewal } from '../store/actions/userActions';
import store from '../store/store';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import TwoStepsModal from '../components/Modal/TwoStepsModal';

let json_lang = store.getState().json_lang;

const iaxios = axios.create();
const appVersion = process.env.REACT_APP_VERSION;
const buildVersion = process.env.REACT_APP_BUILD;

const xVersion = `Web panel.dondemand.io ${appVersion}.${buildVersion}`;

iaxios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token') || '';
iaxios.defaults.headers.common['X-Version'] = xVersion;

iaxios.interceptors.response.use( res => {
	    CathTokenRenewal(res);

	    if(res && (res.status < 200) && (res.status > 299)){
	    	return HandleErrors(res);
	    }

	    return res;

  	}, error => {
  		if(error && error.response){
			if(error.response.data && error.response.data.error_code === "ET100"){
				store.dispatch({type: "REMOVE_LOADING"})
				return HandleErrors(error.response);
			}
			return Promise.reject(HandleErrors(error.response));
		}else{
			return Promise.reject(HandleErrors(error));
		}
	}
);

export {iaxios as axios};

export function CathTokenRenewal (res) {
	if( res.headers["authorization"] ){
		localStorage.setItem('token', res.headers["authorization"].split(" ")[1] );
		setupTokenRenewal();
	}
}


export function HandleErrors (res) {
	console.log("res",res)
	let msg_code = res && res.data && res.data.message ? res.data.message:'',
    	errors = res && res.data && res.data.errors ? res.data.errors:'',
	    status = res && res.status,
		out = {
			data: res.data,
			status: res.status,
			title: '',
			message: res.data && res.data.description ? res.data.description : 'generic',
		    level: 4
		};
    switch (status){
    	case 400:
    		out.title = `Error ${res.data && res.data.error_code}: ${json_lang.errors.title_400}`;
    		switch (msg_code) {
    			case 'error_deleting': /* xHACER: este trae características extra */
	    			out.message = json_lang.errors.on_delete_des;
	    			break;

	    		case 'error_restoring':
	    			out.message =  json_lang.errors.on_restore_des;
	    			break;

	    		case 'scheduling_date_too_low':
	    		case 'scheduling_date_too_high':
	    			out.message = json_lang.errors.bad_schedule_des;
	    			break;

				case 'token_invalid':
					out.message = json_lang.errors.token_invalid_des;
					invalidateSession();
					break;

				case 'confirmation_token_invalid':
					out.message = json_lang.errors.token_invalid_des2;
					break;

				case 'branch_does_not_have_address':
					out.message = json_lang.errors.branch_does_not_have_address;
					break;

				case 'branch_not_enabled':
					out.message = json_lang.errors.branch_not_enabled;
					break;

				case 'branch_enabled':
					out.message = json_lang.errors.branch_enabled;
					break;

				case 'branch_not_visible':
					out.message = json_lang.errors.branch_not_visible;
					break;

				case 'branch_visible':
					out.message = json_lang.errors.branch_visible;
					break;

				case 'branch_not_featured':
					out.message = json_lang.errors.branch_not_featured;
					break;

				case 'branch_featured':
					out.message = json_lang.errors.branch_featured;
					break;

				case 'branch_does_not_have_stock':
					out.message = json_lang.errors.branch_does_not_have_stock;
					break;

				case 'not_allowed':
					out.message = json_lang.errors.order_requires_auth_from_commerce;
					break;

				case 'already_prepared': 
					out.title = json_lang.errors.already_prepared_title;
					out.message = json_lang.errors.already_prepared;
					break;

				case 'two_steps_verification':
					const promiseResolverWrapper = {};
					const promise = new Promise((resolve) => {
						promiseResolverWrapper.resolve = resolve;
					});
					const ref = modal(out.data, res.config, true, promiseResolverWrapper.resolve)
					ReactDOM.render(
						ref,
						document.getElementById("two-steps-verification")
					);
					return promise;
				default:
					out.message = 'generic';
					break;
	    	}
	    	break;

    	case 401:
    		out.title = `Error ${res.data && res.data.error_code}: ${json_lang.errors.title_401}`;
    		switch (msg_code) {
    			case 'token_expired':  // luego de 2 semanas sin validar o sin iniciar sesión
	    			out.message = json_lang.errors.token_expired_des;
	    			invalidateSession();
    				break;

    			case 'token_invalid':
					out.message = json_lang.errors.token_invalid_des;
	    			invalidateSession();
    				break;

    			case 'invalid_credentials':
	    			out.message = json_lang.errors.invalid_credentials_des;
    				break;

    			case 'token_not_provided':
    				out.message = json_lang.errors.token_not_provided_des;
    				break;

    			default:
    				out.message = 'generic';
    			break;
    		}
    		break;

    	case 403:
    		out.title = `Error ${res.data && res.data.error_code}: ${json_lang.errors.title_403}`;
    		switch (msg_code) {
    			case 'account_disabled':
	    			out.message = json_lang.errors.token_not_provided_des;
	    			break;

	    		case 'account_blocked':
	    			out.message = json_lang.errors.account_blocked_des;
	    			break;

	    		case 'account_unconfirmed':
	    			out.message = json_lang.errors.account_unconfirmed_des;
	    			break;

	    		case 'account_mismatches':
	    			out.message = json_lang.errors.account_mismatches_des;
	    			break;

	    		case 'company_disabled':
	    			out.message = json_lang.errors.company_disabled;
	    			break;

	    		case 'feature_disabled':
	    			out.message = json_lang.errors.feature_disabled_des;
	    			break;

	    		case 'target_too_high':
	    			out.message = json_lang.errors.target_too_high_des;
	    			break;

				case 'forbidden':
					out.title = 'Esta funcionalidad no está disponible';
					out.message = 'por favor comunicate con soporte';
					break;

	    		default:
					break;
	    	}
	    	break;

    	case 404:
			switch(msg_code){
				case 'generic_error':
					out.title = "Por favor seleccione un comercio";
					out.message = "";
					break;

				case 'invalid_url_parameters':
					out.title = "Por favor seleccione un comercio";
					out.message = "";
					break;

				default:
					break;
			}
			// este es el que estaba antes
			// out.message = json_lang.errors.title_404;
			break;
			
    	case 405:
    		out.message = json_lang.errors.title_405;
    		break;

    	case 409:
    		out.title = `Error ${res.data && res.data.error_code}: ${json_lang.errors.title_409}`;
    		out.title = json_lang.errors.title_409;
    		switch (msg_code) {
    			case 'already_exists':
	    			out.message = json_lang.errors.already_exists_title_des;
    				break;

    			case 'token_invalid':
	    			out.message = json_lang.errors.token_invalid_des;
	    			invalidateSession();
    				break;

    			case 'invalid_credentials':
	    			out.message = json_lang.errors.invalid_credentials_des;
					break;

    			case 'token_not_provided':
	    			out.message = json_lang.errors.token_not_provided_des;
    				break;

				case 'attached_branches':
					out.title = "Grupo tiene comercios asociados";
					let re = /\(([a-zA-Z ]+)\)/; // captura de la resp que trae el api, el nombre del branch_group
					let branch_group = re.exec(out.message) ? re.exec(out.message)[1] : '';
					out.message = json_lang.errors.branch_attached_to_group.replace("{branch_group}", branch_group);
					break;

    			default:
					break;
    		}
    		break;

    	case 422:
    		out.title = `Error ${res.data && res.data.error_code}: ${json_lang.errors.title_422}`;

			if (msg_code){
				if (out.data && out.data.error_code === "ER422" && out.data.errors.image) {
					if (out.data.errors.image[0].indexOf("invalid_dimensions") !== -1) {
						out.message = "El archivo excede el tamaño máximo"
					}
				}
				else if (out.data && out.data.errors.password) {
					if (out.data.errors.password[0].indexOf("min 5 characters") !== -1) {
						out.message = "Contraseña muy corta. Min 5 caracteres"
					}
				}else if(out.data && out.data.errors.target_type){
					if(out.data.errors.target_type[0] === "The selected target type is invalid."){
						out.title = 'Error al registrar banner'
						out.message = 'Por favor complete los campos requeridos'
					}

				}else if(Object.keys(out.data.errors).length > 0){
					let txt = ''
					for(let i = 0; i<= Object.keys(out.data.errors);i++){
						let key_errors = Object.keys(out.data.errors)[i];
						let key_values = Object.values(out.data.errors)[i];
						txt = txt +`${ key_errors.replaceAll("_", " ").replaceAll(".", " ")}: ${ key_values}`
					}
					out.message = txt;
				}
				//out.message = json_lang.errors.des_422;
			}
    			

    		else if (errors) {
    			console.log('error 422 '.JSON.stringify(res.data));
    			for(let e in errors){
    				console.log(e);
    			}
    		}
    		break;

		case 423:
			out.title = `Error ${res.data && res.data.error_code}: ${json_lang.errors.company_in_service_title}`;
    		out.message = json_lang.errors.company_in_service_msg;
    		break;

    	case 429:
    		out.title = `Error ${res.data && res.data.error_code}: ${json_lang.errors.des_422}`;
    		out.message = json_lang.errors.des_422;
    		break;

		default:
			out.title = '';
    		out.message = json_lang.errors.network_error;
			break;
    }
    //out.message= res.data && res.data.localized_error ? res.data.localized_error : res.data && res.data.message
    console.log("out ",out)
	return out;
}


const invalidateSession = () => {
	localStorage.clear();
    window.location.reload();
}

const modal = (data, config, toggleModal, promiseResolver) => {
	return (
		<Provider store={store}>
			<TwoStepsModal 
				title={data.alert_title}
				message={data.alert_message}
				data={data}
				config={config}
				toggleModal={toggleModal}
				promiseResolver={promiseResolver}
			/>
		</Provider>
	)
}


// WEBPACK FOOTER //
// ./src/handlers/RequestHandler.js